import { env } from '../env';

export const publicRuntimeConfig = {
  appName: 'traeger' as const,
  auth: {
    url: env.NEXT_PUBLIC_AUTH_API_URL,
  },
  bv: {
    environment: env.NEXT_PUBLIC_BV_ENVIRONMENT,
  },
  commerceProvider: env.NEXT_PUBLIC_COMMERCE_PROVIDER,
  locally: {
    companyId: env.NEXT_PUBLIC_LOCALLY_COMPANY_ID,
    companyName: env.NEXT_PUBLIC_LOCALLY_COMPANY_NAME,
    domain: env.NEXT_PUBLIC_LOCALLY_DOMAIN,
  },
  datagrail: {
    customerId: env.NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID,
    containerId: env.NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID,
  },
  gtm: {
    id: env.NEXT_PUBLIC_GTM_ID,
  },
  sentry: {
    dsn:
      (process.env.NODE_ENV !== 'development' || !!env.NEXT_PUBLIC_USE_SENTRY) &&
      env.NEXT_PUBLIC_SENTRY_DSN,
    environment: env.NEXT_PUBLIC_SENTRY_ENV,
  },
  reCaptcha: {
    sitekey: env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  },
  loadMarketingScripts: env.NEXT_PUBLIC_LOAD_MARKETING_SCRIPTS,
  base: env.NEXT_PUBLIC_WEB_ENV,
  appEnv: env.NEXT_PUBLIC_APP_ENV,
  graphqlApiUrl: env.NEXT_PUBLIC_GRAPHQL_API_URL,
  greenhouseDepsUrl: env.NEXT_PUBLIC_GREENHOUSE_DEPTS_URL,
  apiMocking: env.NEXT_PUBLIC_API_MOCKING,
  shopifyCheckoutUrl: env.NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL,
  invalidDeliveryKeys: env.NEXT_PUBLIC_INVALID_DELIVERY_KEYS,
  revalidate: {
    pageTime: env.NEXT_PUBLIC_REVALIDATE_PAGE_TIME,
    layoutTime: env.NEXT_PUBLIC_REVALIDATE_LAYOUT_TIME,
    searchTime: env.NEXT_PUBLIC_REVALIDATE_SEARCH_TIME,
  },
};
